<template>
  <div>
    <populate-form
      formTitle="自動接受劃位時段規則設定"
      fkey="aarf01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <b-table
      stacked="sm"
      :items="autoAcceptRules"
      :fields="fields"
    >
      <template v-slot:cell(actions)="row">
        <b-button @click="showEditRule(row.item)">修改</b-button>
        <b-button @click="removeAutoAcceptRule(row.item.id)">刪除</b-button>
      </template>
    </b-table>
    <b-modal
      v-model="modalShowAdd" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="新增自動接受劃位時段規則"
        fkey="aara01"
        ref="addForm"
        :parentVue="this"
        populateOptionVar="addOptions"
        formDataObjVar="addData"
      ></populate-form>
    </b-modal>
    <b-modal
      v-model="modalShowEdit" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="編輯自動接受劃位時段規則"
        fkey="aare01"
        ref="editForm"
        :parentVue="this"
        populateOptionVar="editOptions"
        formDataObjVar="editData"
      ></populate-form>
    </b-modal>
  </div>
</template>

<script>


export default {
  name: 'StoreAutoAcceptRuleManage',
  components:{
    
  },
  props: {
    'checkTimeArrStr':Function,
  },
  data: function () {
    return {
      modalShowAdd:false,
      modalShowEdit:false,
      service_minute_unit:30,
      autoAcceptRules:[],
      fields:[
        {
          key:'display',
          label:'規則'
        },
        {
          key:'actions',
          label:'操作'
        },
      ],
      filterData:{},
      filterOptions:[
        {
          componentType:'b-button',
          col:3,
          placeholder:"新增",
          execCallback:this.showAddRule
        },
      ],
      editData:{},
      editOptions:[
        {
          componentType:'b-form-select',
          defaultValue:'0',
          akey:'nth_weekday',
          dataOptions:[{text:'每週',value:'0'},{text:'每個月第一個',value:'1'},{text:'每個月第二個',value:'2'},{text:'每個月第三個',value:'3'},{text:'每個月第四個',value:'4'}],
          col:3,
          disabled:true,
        },
        {
          componentType:'b-form-select',
          defaultValue:'0',
          akey:'week_day',
          dataOptions:[{text:'週日',value:'0'},{text:'週一',value:'1'},{text:'週二',value:'2'},{text:'週三',value:'3'},{text:'週四',value:'4'},{text:'週五',value:'5'},{text:'週六',value:'ˊ6'}],
          col:3,
          disabled:true,
        },
        {
          componentType:'text',
          col:3,
          akey:'auto_accept_start',
          placeholder:"開始時間",
          defaultValue:"",
          disabled:true,
        },
        {
          componentType:'text',
          col:3,
          akey:'auto_accept_end',
          placeholder:"結束時間",
          defaultValue:"",
          disabled:true,
        },
        {
          componentType:'number',
          akey:'accept_count',
          col:3,
          placeholder:"人次",
          title:"接受人次,值若為2,這段時間已劃位(含自訂)未滿2次即可自動接受",
          defaultValue:"1",
          min:1,
          max:100
        },
        {
          componentType:'text',
          akey:'restrict_start_times',
          col:9,
          placeholder:"限制開始時間(ex:1600,1700)",
          defaultValue:"",
          title:"說明：預設空白即可,若此設定為12:00~18:00且店家設定時段單位是15分鐘,可選劃位開始時間會從12:00,12:15,12:30一路往下產生,此設定是限制可選開始時間,如設定為1200,1300,1400,1500則只有這幾個開始時間會出現在用戶可選自動接受劃位開始時間,12:15,12:30,12:45等時間不提供選擇！",
        },
        {
          componentType:'btn-group',
          col:12,
          buttons:[
            {
              col:3,
              placeholder:'取消',
              execCallback:()=>{this.modalShowEdit = false}
            },
            {
              col:1
            },
            {
              col:3,
              placeholder:'確認',
              execCallback:this.confirmEdit
            },
          ]
        },
      ],
      addData:{},
      addOptions:[
        {
          componentType:'b-form-select',
          defaultValue:'0',
          akey:'nth_weekday',
          dataOptions:[{text:'每週',value:'0'},{text:'每個月第一個',value:'1'},{text:'每個月第二個',value:'2'},{text:'每個月第三個',value:'3'},{text:'每個月第四個',value:'4'}],
          col:3,
        },
        {
          componentType:'b-form-select',
          defaultValue:'0',
          akey:'week_day',
          dataOptions:[{text:'週日',value:'0'},{text:'週一',value:'1'},{text:'週二',value:'2'},{text:'週三',value:'3'},{text:'週四',value:'4'},{text:'週五',value:'5'},{text:'週六',value:'ˊ6'}],
          col:3,
        },
        {
          componentType:'vue-timepicker',
          col:3,
          akey:'start_time',
          placeholder:"開始時間(請點擊設定)",
          defaultValue:"",
          minuteInterval:this.service_minute_unit,
          minHour:0,
          maxHour:23,
        },
        {
          componentType:'vue-timepicker',
          col:3,
          akey:'end_time',
          placeholder:"結束時間(請點擊設定)",
          defaultValue:"",
          minuteInterval:this.service_minute_unit,
          minHour:0,
          maxHour:23,
        },
        {
          componentType:'number',
          akey:'accept_count',
          col:3,
          placeholder:"人次",
          title:"接受人次,值若為2,這段時間已劃位(含自訂)未滿2次即可自動接受",
          defaultValue:"1",
          min:1,
          max:100
        },
        {
          componentType:'text',
          akey:'restrict_start_times',
          col:9,
          placeholder:"限制開始時間(ex:1600,1700)",
          defaultValue:"",
          title:"說明：預設空白即可,若此設定為12:00~18:00且店家設定時段單位是15分鐘,可選劃位開始時間會從12:00,12:15,12:30一路往下產生,此設定是限制可選開始時間,如設定為1200,1300,1400,1500則只有這幾個開始時間會出現在用戶可選自動接受劃位開始時間,12:15,12:30,12:45等時間不提供選擇！",
        },
        {
          componentType:'btn-group',
          col:12,
          buttons:[
            {
              col:4,
              placeholder:'取消',
              execCallback:()=>{this.modalShowAdd = false}
            },
            {
              col:4,
              placeholder:'確認',
              execCallback:this.confirmAdd
            },
          ]
        },
      ],
    }
  },
  methods: {
    showAddRule() {
      this.addData.nth_weekday = ''
      this.addData.week_day = ''
      this.addData.start_time = ''
      this.addData.end_time = ''
      this.addData.accept_count = 1
      this.addData.restrict_start_times = ''

      this.$refs.addForm.initDefault()
      this.modalShowAdd = true
    },
    showEditRule(item) {
      this.editData = this.CpObj(item)
      this.$refs.editForm.refreshModelVar()
      this.modalShowEdit = true
    },
    removeAutoAcceptRule(id) {
      this.$bus.fnShowConfirm("確認要刪除嗎?", () => {
        let Param = {
          'module':'store',
          'method':'removeStoreAutoAcceptRule',
          'store_id': this.$bus.session.merchant_store_id,
          'rule_id':id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              if (!data.data.confirm_remove) {
                vm.$bus.fnClosePopup()
                vm.$bus.fnShowInfo(data.msg)
                return
              }
            }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("刪除完成")
          vm.searchAutoAcceptRules()
        }, this)
      })
    },
    searchAutoAcceptRules() {
      let Param = {
        'module':'store',
        'method':'getStoreAutoAcceptRules',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.autoAcceptRules =data.data
      }, this)
    },
    confirmEdit() {
      if (!this.checkTimeArrStr(this.editData.restrict_start_times, this.service_minute_unit)) {
        this.$refs.editForm.triggerAlert('限制可用預約開始時間格式錯誤(起訖時間內的HHmm用逗號串起來且分鐘需為店家最小時間單位倍數')
        return
      }
      let Param = {
        'module':'store',
        'method':'updateStoreAutoAcceptRule',
        'store_id': this.$bus.session.merchant_store_id,
        'rule_id':this.editData.id,
        'accept_count':this.editData.accept_count,
        'restrict_start_times':this.editData.restrict_start_times?this.editData.restrict_start_times:'',
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$refs.addForm.triggerAlert(data.msg)
          return
        }
        setTimeout(() => {
          vm.searchAutoAcceptRules()
        }, 50);
        vm.$bus.fnClosePopup()
        vm.$bus.fnShowInfo("修改設定成功")
        vm.modalShowEdit = false
      }, this)
    },
    confirmAdd() {
      if (!this.addData.start_time || !this.addData.end_time) {
        this.$refs.addForm.triggerAlert('規則的起訖時間未選擇完成')
        return
      }
      if (this.addData.start_time > this.addData.end_time) {
        this.$refs.addForm.triggerAlert('時間起訖錯誤')
        return
      }
      if (!this.checkTimeArrStr(this.addData.restrict_start_times, this.service_minute_unit)) {
        this.$refs.addForm.triggerAlert('限制可用預約開始時間格式錯誤(起訖時間內的HHmm用逗號串起來且分鐘需為店家最小時間單位倍數')
        return
      }
      let Param = {
        'module':'store',
        'method':'addStoreAutoAcceptRule',
        'store_id': this.$bus.session.merchant_store_id,
        'nth_weekday':this.addData.nth_weekday,
        'week_day':this.addData.week_day,
        'auto_accept_start':this.addData.start_time,
        'auto_accept_end':this.addData.end_time,
        'accept_count':this.addData.accept_count,
        'restrict_start_times':this.addData.restrict_start_times,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$refs.addForm.triggerAlert(data.msg)
          return
        }
        setTimeout(() => {
          vm.searchAutoAcceptRules()
        }, 50);
        vm.$bus.fnClosePopup()
        vm.$bus.fnShowInfo("添加設定成功")
        vm.modalShowAdd = false
      }, this)
    },
  },
  computed: {
    
  },
  created() {
    if (!this.$bus.session.hasOwnProperty('store_service_rule')) {
      // 沒有就抓api寫到session裡,之後讀session
      let Param = {
        'module':'store',
        'method':'getStoreServiceRule',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.session.store_service_rule = data.data
        vm.service_minute_unit = parseInt(data.data.service_minute_unit)
      }, this)
    }
  },
  mounted () {
    this.$refs.filterForm.initDefault()
    setTimeout(() => {
      this.searchAutoAcceptRules()
      this.addOptions[2].minuteInterval = this.service_minute_unit
      this.addOptions[3].minuteInterval = this.service_minute_unit
      this.$refs.addForm.initDefault()
      
    }, 100);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
